export default "__VITE_ASSET__Cezf5_vn__"